import './application.css'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'

const appName = 'MakeMoney'

const pages = import.meta.glob('../pages/**/*.tsx')

function resolvePage(name: string) {
  const path = `../pages/${name}.tsx`
  if (!pages[path]) {
    throw new Error(`Page not found: ${path}`)
  }
  return pages[path]()
}

createInertiaApp({
  title: (title) => title ? `${title} - ${appName}` : appName,
  resolve: resolvePage,
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
  progress: {
    color: '#4B5563',
  },
})
